// extracted by mini-css-extract-plugin
export default {"sensors-container":"RoomSensors_sensors-container__ge-r2","sensors-title-container":"RoomSensors_sensors-title-container__VTjwz","btn-close":"RoomSensors_btn-close__xpjqn"};